<template>
	<Transition name="fadeInOut" mode="out-in">
		<slot />
	</Transition>
</template>

<script>
export default {};
</script>

<style scoped>
.fadeInOut-enter-active,
.fadeInOut-leave-active {
	transition: all 0.45s;
	height: auto;
}

.fadeInOut-leave-to,
.fadeInOut-enter-from {
	opacity: 0;
}

.fadeInOut-leave-from,
.fadeInOut-enter-to {
	opacity: 1;
}
</style>
